import FormControl from "@mui/material/FormControl";
import { Chip } from "@mui/material";
import Typography, { TypographyProps } from "@mui/material/Typography";
import styled from "styled-components";

export const ProjectsContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const Description = styled(Typography)`
  margin: ${({ theme }) => theme.spacing(1, 0, 0, 0)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  font-size: smaller;
`;

export const Description2 = styled(Typography)`
  margin: ${({ theme }) => theme.spacing(0.5, 0, 3, 0)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  font-size: smaller;
`;

export const CurrencyFormControl = styled(FormControl)`
  width: 120px;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
`;

export const DetailsTitle = styled.span`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.primary.main
      : theme.palette.text.secondary};
  font-weight: 500;
  font-size: 0.9rem;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const DetailsInfo = styled.span`
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const DetailsInfoColored = styled(DetailsInfo)`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.text.primary
      : theme.palette.primary.main};
  font-weight: 450;
  font-size: 0.9rem;
`;

export const DetailsInfoGray = styled(DetailsInfo)`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.text.primary
      : theme.palette.text.secondary};
  font-weight: 450;
  font-size: 0.9rem;
`;

export const HeaderBlock = styled("div")`
  min-height: 72px;
`;

export const Title = styled(Typography)<
  TypographyProps<"h2", { component: "h2" }>
>`
  margin-right: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Tag = styled(Chip)`
  margin-right: ${({ theme }) => theme.spacing(1)};
  /* font-weight: 450; */
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100]};
`;

export const StubContainer = styled.div`
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
